import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getRolePrivileges } from 'src/app/privileges/privileges.selector';
import { RolesFilterOption } from './models/role-filter-option';
import { RolePrivileges } from './models/role-privileges';
import { RoleOrderingOptions, RoleRegisterOptions } from './models/role-register-options';
import { RoleRegisterListItem } from './models/role-register-results.model';
import { createRole, roleRegisterAdapterActions, roleRegisterInitialFilter } from './state/role-register.actions';
import { selectors } from './state/role-register.reducer';

@Directive()
export class RoleRegister
   extends Register<RoleRegisterListItem, RoleRegisterOptions, RoleOrderingOptions>
   implements OnInit
{
   columns: string[];

   filters: RolesFilterOption[];

   entityName = 'Role';

   rolePrivileges$: Observable<RolePrivileges>;

   constructor(public store: Store) {
      super(store, selectors, roleRegisterAdapterActions);
      this.rolePrivileges$ = store.pipe(select(getRolePrivileges));
   }

   ngOnInit() {
      this.store.dispatch(roleRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createRole());
   }
}
